module.exports = __webpack_public_path__ + "static/FMCG2-2427a8f85116e414ce572f429f3ad54f.png";